'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRANS = [];
window.MISSING_TRANSLATIONS = [];

var Translate = function () {
    function Translate() {
        (0, _classCallCheck3.default)(this, Translate);
    }

    (0, _createClass3.default)(Translate, null, [{
        key: 'simpleMessage',
        value: function simpleMessage(toTranslate) {
            if (TRANS[toTranslate]) {
                return TRANS[toTranslate];
            } else {
                window.MISSING_TRANSLATIONS.indexOf(toTranslate) === -1 && window.MISSING_TRANSLATIONS.push(toTranslate);
                console.error('Message "' + toTranslate + '" not found');
                return 'NotFound';
            }
        }
    }]);
    return Translate;
}();

exports.default = Translate;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvVHJhbnNsYXRlLmpzeCJdLCJuYW1lcyI6WyJUUkFOUyIsIndpbmRvdyIsIk1JU1NJTkdfVFJBTlNMQVRJT05TIiwiVHJhbnNsYXRlIiwidG9UcmFuc2xhdGUiLCJpbmRleE9mIiwicHVzaCIsImNvbnNvbGUiLCJlcnJvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLElBQU1BLFFBQVEsRUFBZDtBQUNBQyxPQUFPQyxvQkFBUCxHQUE4QixFQUE5Qjs7SUFFcUJDLFM7Ozs7Ozs7c0NBQ0lDLFcsRUFBYTtBQUM5QixnQkFBSUosTUFBTUksV0FBTixDQUFKLEVBQXdCO0FBQ3BCLHVCQUFPSixNQUFNSSxXQUFOLENBQVA7QUFDSCxhQUZELE1BRU87QUFDSEgsdUJBQU9DLG9CQUFQLENBQTRCRyxPQUE1QixDQUFvQ0QsV0FBcEMsTUFBcUQsQ0FBQyxDQUF0RCxJQUEyREgsT0FBT0Msb0JBQVAsQ0FBNEJJLElBQTVCLENBQWlDRixXQUFqQyxDQUEzRDtBQUNBRyx3QkFBUUMsS0FBUixDQUFjLGNBQWNKLFdBQWQsR0FBNEIsYUFBMUM7QUFDQSx1QkFBTyxVQUFQO0FBQ0g7QUFDSjs7Ozs7a0JBVGdCRCxTIiwiZmlsZSI6IlRyYW5zbGF0ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFRSQU5TID0gW107XG53aW5kb3cuTUlTU0lOR19UUkFOU0xBVElPTlMgPSBbXTtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVHJhbnNsYXRlIHtcbiAgICBzdGF0aWMgc2ltcGxlTWVzc2FnZSh0b1RyYW5zbGF0ZSkge1xuICAgICAgICBpZiAoVFJBTlNbdG9UcmFuc2xhdGVdKSB7XG4gICAgICAgICAgICByZXR1cm4gVFJBTlNbdG9UcmFuc2xhdGVdO1xuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgd2luZG93Lk1JU1NJTkdfVFJBTlNMQVRJT05TLmluZGV4T2YodG9UcmFuc2xhdGUpID09PSAtMSAmJiB3aW5kb3cuTUlTU0lOR19UUkFOU0xBVElPTlMucHVzaCh0b1RyYW5zbGF0ZSk7XG4gICAgICAgICAgICBjb25zb2xlLmVycm9yKCdNZXNzYWdlIFwiJyArIHRvVHJhbnNsYXRlICsgJ1wiIG5vdCBmb3VuZCcpO1xuICAgICAgICAgICAgcmV0dXJuICdOb3RGb3VuZCc7XG4gICAgICAgIH1cbiAgICB9O1xufVxuIl19